'use client'

import { useEffect } from 'react'

import { sentryCall } from '@/lib/log/sentry-client'

type Props = {
  error: Error & { digest?: string }
  reset: () => void
}

// Root-level boundary. Fires when the root layout itself throws, so we must
// render <html><body> ourselves. English-only because we're above the i18n
// provider tree.
export default function GlobalError({ error, reset }: Props) {
  useEffect(() => {
    sentryCall((Sentry) => Sentry.captureException(error))
  }, [error])

  return (
    <html lang="en">
      <body>
        <main className="flex min-h-[60vh] flex-col items-center justify-center gap-6 px-4 py-16">
          <h1 className="text-navy text-4xl font-bold">Something went wrong</h1>
          <p className="text-navy-60 text-center text-lg">An unexpected error occurred. Our team has been notified.</p>
          <button
            type="button"
            onClick={reset}
            data-tracking="ignore"
            className="bg-lapis hover:bg-navy cursor-pointer rounded-full px-6 py-3 text-white transition-colors"
          >
            Try again
          </button>
        </main>
      </body>
    </html>
  )
}
